import { render } from "./AgedCard.vue?vue&type=template&id=3d080b02&scoped=true"
import script from "./AgedCard.vue?vue&type=script&lang=js"
export * from "./AgedCard.vue?vue&type=script&lang=js"

import "./AgedCard.scss?vue&type=style&index=0&id=3d080b02&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d080b02"]])

export default __exports__